import { useTheme } from '@mui/material';
import { formatAmount } from '@zeta-core';
import { ApexOptions } from 'apexcharts';
import React from 'react';
import ReactApexChart from 'react-apexcharts';

interface PortfolioPieChartProps {
  data: Record<string, number>;
}

const PortfolioPieChart: React.FC<PortfolioPieChartProps> = ({ data }) => {
  const theme = useTheme();
  const labels = Object.keys(data);
  const series = Object.values(data);
  const totalValue = series.reduce((acc, value) => acc + value, 0);

  const options: ApexOptions = {
    chart: {
      type: 'donut',
    },
    plotOptions: {
      pie: {
        donut: {
          size: '80%',
          labels: {
            show: true,
            total: {
              showAlways: true,
              show: true,
              label: 'Total Value',
              formatter: () => `${formatAmount(totalValue)}`,
              color: theme.palette.text.secondary,
              fontSize: '14px', // Similar to Typography variant="h6"
              fontWeight: 'bold',
              fontFamily: theme.typography.fontFamily,
            },
          },
        },
      },
    },
    colors: [theme.palette.primary.light, '#F59E0B', '#8B5CF6', '#4F46E5', '#06B6D4'],
    stroke: {
      show: false,
    },
    labels: labels,
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: true,
      position: 'bottom',
    },
    tooltip: {
      enabled: true,
      y: {
        formatter: (value) => `${formatAmount(value)}`,
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 300,
          },
        },
      },
    ],
  };

  return (
    <div className="w-full max-w-md mx-auto">
      <ReactApexChart options={options} series={series} type="donut" height={350} />
    </div>
  );
};

export default PortfolioPieChart;
